// extracted by mini-css-extract-plugin
export default {"Inputs":"TerminarTrabajoUnidades_Inputs__0oizI","Input":"TerminarTrabajoUnidades_Input__IML5f","message":"TerminarTrabajoUnidades_message__wgFsA"};